import './index.sass';

const popupsGallery = function() {};

export default popupsGallery;
